<template>
    <div class="box">
        <el-form :inline="true" class="demo-form-inline" id="searchBox" label-width="70px" @submit.native.prevent>
            <el-form-item label="UDI码">
                <el-input class="UDIcode" v-model="UDIcode" ref="UDIcode" @keyup.enter.native="UDInative('outNum')" placeholder="UDI码"></el-input>
                <p style="color: red;">扫UDI码</p>
            </el-form-item>
            <el-form-item label="数量" v-if="scanCodeType!=1">
                <el-input style="width: 120px;" type="number" ref="outNum" @keyup.enter.native="UDInative('keydown')" @input="UDIinput()" v-model="outNum" placeholder="数量"></el-input>
            </el-form-item>
            <el-form-item>
                <el-radio v-model="scanCodeType" :label="2">箱码</el-radio>
                <el-radio v-model="scanCodeType" :label="1">盒码</el-radio>
            </el-form-item>
        </el-form>
        <el-form :inline="true" class="demo-form-inline" id="searchBox1" label-width="70px" @submit.native.prevent>
            <el-form-item label="批号">
                <el-input style="width: 130px;" type="text" v-model="UDIobj.batchno" ref="batchno" @keyup.enter.native="nativeClick('prodate')"></el-input>
            </el-form-item>
            <el-form-item label="生产日期">
                <df-date :isType="true" class="date" ref="prodate" :isShowLong="false" :isLongTime="false" :isNull=" true" v-model="UDIobj.prodate" @keyup.enter.native="nativeClick('expidate')"></df-date>
            </el-form-item>
            <el-form-item label="失效日期">
                <df-date :isType="true" class="date" :isShowLong="false" ref="expidate" :isLongTime="false" :isNull=" false" v-model="UDIobj.expidate" @keyup.enter.native="nativeClick('keydown')"></df-date>
            </el-form-item>
            <el-form-item label="序列号">
                <el-input style="width: 130px;" type="text" v-model="UDIobj.xlh"></el-input>
            </el-form-item>
            <el-form-item label="数量">
                <el-input style="width: 130px;" type="number" v-model="UDIobj.outNum"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">更新</el-button>
            </el-form-item>
        </el-form>
        <div class="btn">
            <el-button type="danger" size="mini" @click="batchDelete">批量删除</el-button>
        </div>
        <u-table @selection-change="handleSelectionChange" ref="plTable" :data="UDIlist" use-virtual showBodyOverflow="title" :height="tableHeight" showHeaderOverflow="title" :row-height="30" @row-click="rowClick" border>
            <u-table-column type="selection" width="55">
            </u-table-column>
            <u-table-column :resizable="true" show-overflow-tooltip prop="type" label="操作" fixed="left" min-width="80">
                <template slot-scope="scope">
                    <el-button type="danger" size="mini" @click="delClick(scope.$index)">删除</el-button>
                </template>
            </u-table-column>
            <u-table-column :resizable="true" type="index" width="50" label="序号" />
            <u-table-column :resizable="true" show-overflow-tooltip prop="bgmName" label="通用名称" min-width="160" />
            <u-table-column :resizable="true" show-overflow-tooltip prop="bgmCode" label="商品编码" min-width="150" />
            <u-table-column :resizable="true" show-overflow-tooltip prop="fileNumber" label="档案编号" min-width="100" />
            <u-table-column :resizable="true" show-overflow-tooltip prop="spec" label="规格" min-width="120" />
            <u-table-column :resizable="true" show-overflow-tooltip prop="manufacturer" label="生产厂家" min-width="160" />
            <u-table-column :resizable="true" show-overflow-tooltip prop="bgiRegistno" label="注册证号" min-width="150" />
            <u-table-column :resizable="true" show-overflow-tooltip prop="udiCode" label="UDI码" min-width="600" />
            <u-table-column :resizable="true" show-overflow-tooltip prop="diCode" label="DI码" min-width="200" />
            <u-table-column :resizable="true" show-overflow-tooltip prop="batchno" label="批号" min-width="120" />
            <u-table-column :resizable="true" show-overflow-tooltip prop="prodatestr" label="生产日期(字符串)" min-width="120" />
            <u-table-column :resizable="true" show-overflow-tooltip prop="expidatestr" label="有效期(字符串)" min-width="120" />
            <u-table-column :resizable="true" show-overflow-tooltip prop="outNum" label="数量" min-width="90" />
            <u-table-column :resizable="true" show-overflow-tooltip prop="xlh" label="序列号" min-width="120" />
            <u-table-column :resizable="true" show-overflow-tooltip prop="prodate" label="生产日期" min-width="110">
                <template slot-scope="scope">
                    <span v-if="scope.row.prodate">
                        {{ $moment(new Date(scope.row.prodate)).format('YYYY-MM-DD') }}
                    </span>
                </template>
            </u-table-column>
            <u-table-column :resizable="true" show-overflow-tooltip prop="expidate" label="有效期" min-width="110">
                <template slot-scope="scope">
                    <span v-if="scope.row.prodate">
                        {{ $moment(new Date(scope.row.expidate)).format('YYYY-MM-DD') }}
                    </span>
                </template>
            </u-table-column>

        </u-table>
        <div class="floor">
            <el-button type="" @click="clearClick" style="margin-right: 20px;">取消</el-button>
            <el-button type="primary" @click="submitClick">保存</el-button>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    name: "salesUDIscanCode",
    props: ['actionData'],
    data() {
        return {
            tableHeight: 300,
            UDIcode: "",
            outNum: 0,
            scanCodeType: 1,
            selectIndex: 0,
            UDIlist: [],
            UDIobj: {
                batchno: "",
                prodate: "",
                expidate: "",
                bgmId: "",
                bgmName: "",
                bgmCode: "",
                fileNumber: "",
                spec: "",
                manufacturer: "",
                bgiRegistno: "",
                outNum: 0,
                udiCode: "",
                xlh: "",
                diCode: "",
                bgColor: "",
                type: "",
                expidatestr: "",
                piCode: "",
                prodatestr: "",
            },
            selectedRows: [],
        }
    },
    watch: {
        scanCodeType() {
            if (this.scanCodeType == 1) {
                this.outNum = 1
            } else {
                this.outNum = 0
            }
        }
    },
    created() {
        this.$nextTick(() => {
            this.openBox()
            setTimeout(() => {
                this.$refs['UDIcode'].focus()
                this.heightChange()
            }, 100)
        })
    },
    methods: {
        batchDelete() {
            if (this.selectedRows.length == 0) {
                this.$message.error("请选择要删除的行！")
                return
            }
            this.UDIlist = this.UDIlist.filter(item => this.selectedRows.indexOf(item) == -1)
            this.$refs['plTable'].clearSelection()
            this.selectedRows = []
        },
        handleSelectionChange(val) {
            this.selectedRows = val
        },
        UDInative(type) {
            if (this.UDIcode == "") {
                return this.$message.error("请扫UDI码！")
            }
            if (String(this.UDIcode).length <= 18) {
                return
            }
            if (this.scanCodeType != 1 && type != 'keydown') {
                this.$refs[type].focus()
            } else if (type == 'keydown') {
                this.UDI(true)
                this.UDIcode = ""
            } else {
                this.UDI(false)
                this.UDIcode = ""
            }
        },
        async UDI(val) {
            var arr1 = this.UDIlist.filter(val => val.udiCode == this.UDIcode)
            if (arr1.length > 0) {
                return this.$message.error("该UDI码已扫过！")
            }
            var token = null
            token = sessionStorage.getItem('token')
            axios({
                // 请求地址
                url: `${this.$store.state.webConfig.dataTwo.requestUrl}/pscha/identifyUDI?udiCode=${this.UDIcode}`,
                method: 'POST',
                headers: {
                    token: token
                },
            }).then(res => {
                if (res.data.status == 200) {
                    this.UDIlist.push({})
                    for (const key in this.UDIobj) {
                        this.$set(this.UDIlist[this.UDIlist.length - 1], key, res.data.result[key])
                    }
                    if (val) {
                        this.$set(this.UDIlist[this.UDIlist.length - 1], 'outNum', Number(this.outNum || 0))
                    } else {
                        this.$set(this.UDIlist[this.UDIlist.length - 1], 'outNum', 1)
                    }
                    this.$refs['UDIcode'].focus()
                    // this.interceptClick(res.data.result, val)

                } else {
                    this.$message.error(res.data.message)
                }

            })

        },
        async interceptClick(val, flag) {
            let params = {}
            params.coId = this.actionData.data.coId
            params.stId = this.actionData.data.stId
            params.udiFtStockDetailDtos = [
                {
                    batchno: val.batchno,
                    bgmId: val.bgmId,
                    expidate: val.expidate,
                    prodate: val.prodate,
                    woadPnumber: 1,
                    xlh: item.xlh
                }
            ]
            console.log(params);
            const res = await this.$http.ftUdiStock(params)
            if (res.status == 200) {
                this.UDIlist.push({})
                for (const key in this.UDIobj) {
                    this.$set(this.UDIlist[this.UDIlist.length - 1], key, val[key])
                }
                if (flag) {
                    this.$set(this.UDIlist[this.UDIlist.length - 1], 'outNum', Number(this.outNum || 0))
                } else {
                    this.$set(this.UDIlist[this.UDIlist.length - 1], 'outNum', 1)
                }
                this.$refs['UDIcode'].focus()
            } else {
                this.$message.error(res.message)
            }
        },
        nativeClick(type) {
            if (this.UDIobj.prodate == "" && type == 'expidate') {
                this.$refs['prodate'].$el[0].focus()
                return
            }
            if (this.UDIobj.expidate == "" && type == 'keydown') {
                this.$refs['expidate'].$el[0].focus()
                return
            }
            if (type == 'keydown') {

            } else {
                this.$refs[type].$el[0].focus()
            }
        },
        openBox() {
            this.UDIlist = this.actionData.UDIlist
        },
        onSubmit() {
            for (const key in this.UDIobj) {
                this.$set(this.UDIlist[this.selectIndex], key, this.UDIobj[key])
            }
            setTimeout(() => {
                for (const key in this.UDIobj) {
                    this.UDIobj[key] = "";
                }
            }, 100)
        },
        rowClick(row, column, event) {
            this.selectIndex = this.UDIlist.indexOf(row)
            for (const key in this.UDIobj) {
                this.$set(this.UDIobj, key, this.UDIlist[this.selectIndex][key])
            }
        },
        delClick(index) {
            this.UDIlist.splice(index, 1)
        },
        clearClick() {
            this.$emit("clearClick", false)
        },
        async submitClick() {
            this.UDIlist.forEach(item => {
                this.$set(item, 'bgmStr', `${item.bgmId}${item.batchno}${item.prodate}${item.expidate}${item.xlh}`)
            })
            var list = []
            list.push(...this.mergeByKey(this.UDIlist, 'bgmStr'))
            let params = {}
            params.coId = this.actionData.data.coId
            params.stId = this.actionData.data.stId
            params.udiFtStockDetailDtos = list.map(item => {
                return {
                    batchno: item.batchno,
                    bgmId: item.bgmId,
                    expidate: item.expidate,
                    prodate: item.prodate,
                    woadPnumber: item.outNum,
                    xlh: item.xlh
                }
            })
            console.log(params);
            const res = await this.$http.ftUdiStock(params)
            if (res.status == 200) {
                this.$emit("clearClick", true, res.result, this.UDIlist)
            } else {
                this.$message.error(res.message)
            }
        },
        mergeByKey(arr, key) {
            const temp = {};
            arr.forEach(item => {
                const currentKey = item[key];
                if (temp[currentKey]) {
                    temp[currentKey].outNum += item.outNum; // 合并数量
                } else {
                    temp[currentKey] = { ...item }; // 深拷贝避免引用问题
                }
            });
            return Object.values(temp);
        },
        heightChange() {
            var height = document.documentElement.querySelector(".dialogBox").clientHeight
            var topHeight = document.documentElement.querySelector(".dialogBox").querySelector(".el-dialog__header").clientHeight
            var searchHeight = document.documentElement.querySelector(".dialogBox").querySelector("#searchBox").clientHeight
            var searchHeight1 = document.documentElement.querySelector(".dialogBox").querySelector("#searchBox1").clientHeight
            this.tableHeight = height - topHeight - searchHeight - searchHeight1 - 70
        },
    }
}
</script>

<style scoped>
.UDIcode {
    width: calc(98vw - 500px);
}
.floor {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    line-height: 40px;
}
.date ::v-deep .form-control {
    width: 130px !important;
}
.btn {
    padding: 5px 0;
}
</style>